import "../../styles/atoms.scss";

function TitleZ({ title, text, children }) {

  return (
      <div className="title-page-box">
        {title && <h1>{title}</h1>}
        {text && <p>{text}</p>      }
        {children}
      </div>
  );
}

export default TitleZ;
